import React from 'react';
import AssignExternal from './components/assignedViaExternal/index';
import AssignCastle from './components/assignedViaCastle/index';
import { useAssignmentContext } from '../../../../context';

const AssignToStudents = () => {

  const { assignmentAssignedViaDetails } = useAssignmentContext();
  return (
    <>
      {assignmentAssignedViaDetails.id == 1 ? <AssignCastle/> : <AssignExternal/>}

    </>
  );
};

export default AssignToStudents;
